import React, { useEffect, useState } from 'react';
import { getLsItem, setLsItem } from '../../../services/storage/localStorageService';
import Dialog from '../../common/dialog/dialog';
import Tips from '../../common/tips/tips';
import s from './startupMessage.module.scss';

/**
 * The tips, once, on a user's first visit to the library. A dialog like any
 * other: Escape, a click outside, Enter and the button all close it.
 */
export default function StartupMessage() {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(function testPreviouslyShown() {
    if (getLsItem('hasShownStartupMessage') === undefined) {
      setShowMessage(true);
      setLsItem('hasShownStartupMessage', true);
    }
  }, []);

  if (!showMessage) {
    return null;
  }

  const close = () => setShowMessage(false);

  return (
    <Dialog
      title="Tips"
      size="large"
      onClose={close}
      onSubmit={(ev) => {
        ev.preventDefault();
        close();
      }}
    >
      <Tips showHeading={false} />
      <div className={s.btnContainer}>
        <button type="submit" className="button">
          Close
        </button>
      </div>
    </Dialog>
  );
}
